import { KineticHeading } from "@/components/common/Reveal";
import { motion } from "framer-motion";

export default function PageHeader({ overline, titleLines = [], subtitle, testId = "page-header" }) {
  return (
    <section data-testid={testId} className="relative overflow-hidden bg-navy pb-20 pt-40 text-white grain-overlay md:pb-28 md:pt-48">
      <div className="pointer-events-none absolute -right-40 top-0 h-[500px] w-[500px] rounded-full bg-royal/20 blur-[130px]" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
        {overline && <p className="font-body text-xs font-bold uppercase tracking-[0.3em] text-sky">{overline}</p>}
        <h1 className="mt-6 font-heading text-5xl font-light leading-[0.95] tracking-tighter md:text-7xl">
          <KineticHeading lines={titleLines} />
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.8 }}
            className="mt-8 max-w-2xl font-body text-lg leading-relaxed text-slate-300 md:text-xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
